import { NullableDeepPartial } from 'src/graphql/types';
import { Client } from './client.types';

export const DELETED_CLIENT_TEXT = 'Deleted';

/**
 * A soft-deleted client is still shown wherever it is already referenced (e.g. as a conversation
 * participant), but is hidden from lookup/assignment. `deletedAt` is only populated on records
 * fetched with `includeDeleted: true`.
 */
export function isClientDeleted(client?: NullableDeepPartial<Pick<Client, 'deletedAt'>> | null): boolean {
  return Boolean(client?.deletedAt);
}

export function appendDeletedClientTextToName(name = ''): string {
  return `${name} (${DELETED_CLIENT_TEXT})`;
}
